import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AsyncDataService {
  private screenshotSubject = new Subject<string>();
  private notificationSubject = new Subject<any>();
  constructor() {
    //
  }
  setScreenshotString(data: string): void {
    this.screenshotSubject.next(data);
  }
  getScreenshotString(): Observable<string> {
    return this.screenshotSubject.asObservable();
  }
  setNotificationFlag(data: boolean): void {
    this.notificationSubject.next(data);
  }

  getNotificationFlag(): Observable<boolean> {
    return this.notificationSubject.asObservable();
  }
}
